import React from "react";
import styled from "styled-components";

/**
 * Local initials avatar for the drawer panels.
 *
 * The shared `AAvatar` renders `<div className="avatar-div">`, and App.css
 * styles that class globally with a white background, white border and pill
 * radius — which turned every row into a full-width white slab inside the
 * drawer. This keeps the same colour-from-name behaviour without the class.
 */

const hueFromName = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % 360;
};

const Circle = styled.span`
  flex: none;
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff;
  background: ${({ hue }) => `hsl(${hue} 52% 46%)`};
  user-select: none;

  &::after {
    content: "";
    display: ${({ status }) => (status === "offline" ? "none" : "block")};
    position: absolute;
    right: -1px;
    bottom: -1px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: ${({ status }) => (status === "idle" ? "#d97706" : "#12b76a")};
    border: 2px solid ${({ ring }) => ring};
  }
`;

// status: "active" (real activity within the idle window) | "idle" (logged
// in, socket connected, but no activity within the window) | "offline"
// (logged out). See ActiveUsers.js (#264).
const PanelAvatar = ({ firstName, lastName, status = "offline", ringColor = "#fff" }) => {
  const first = (firstName || "").trim();
  const last = (lastName || "").trim();
  const full = `${first} ${last}`.trim() || "Unknown User";
  const initials =
    `${first[0] || ""}${last[0] || ""}`.toUpperCase() ||
    full.slice(0, 2).toUpperCase();

  return (
    <Circle
      hue={hueFromName(full)}
      status={status}
      ring={ringColor}
      title={full}
      aria-hidden="true"
    >
      {initials}
    </Circle>
  );
};

export default PanelAvatar;
